import { Get, Put } from "@configs/Axios";
import { EventStatus, EventType, Union } from "@custom-types/Types";
import { EventWidgetType } from "@queries/Events";

interface GetNotificationTotalResponse {
  total: number;
  unreadTotal: number;
}

interface GetNotificationResponse {
  total: number;
  page: number;
  limit: number;
  data: NotificationType[];
}

export const SystemlogWidgetType = {
  REPORT_SHARE: "reportShare"
} as const;

export const notificationQueryType = {
  ...EventWidgetType,
  ...SystemlogWidgetType
};

export type NotificationQueryType = Union<typeof notificationQueryType>;

export enum SystemLogEnum {
  Event = "Event",
  Systemlog = "Systemlog"
}

export const SYSTEM_LOG_TYPE = {
  REPORT_SHARE: "REPORT_SHARE"
} as const;

export type SystemLogType = Union<typeof SYSTEM_LOG_TYPE>;

export interface NotificationData {
  id: string;
  type: SystemLogEnum | string;
  timestamp: string;
  eventName: string;
  read: boolean;
}

export interface SystemLogNotificationData extends NotificationData {
  eventId: string;
  status: string;
  userId: string;
  eventType: SystemLogType;
  info: {
    reportTitle: string;
    sharedByUserId: string;
    sharedByUsername: string;
    isSharedSuccess: boolean;
    failedReason: string;
    sharedToUserId: string;
    reportId: string;
  };
}
export interface EventNotificationData extends NotificationData {
  orgId?: string;
  read: boolean;
  device: Device;
  widgets: Widget[];
  status: EventStatus;
  eventType: EventType;
  thumbnail: string;
}

export type NotificationType =
  | SystemLogNotificationData
  | EventNotificationData;

interface Device {
  id: string;
  name: string;
  channel: number;
  ruleName: string;
  ruleIndex: number;
}

interface Widget {
  id: string;
  name: string;
  locationName: string;
  dashboard: Dashboard;
  status?: string;
}

interface Dashboard {
  id: string;
  name: string;
}

export const notificationAPI = {
  getNotifications: async ({
    orgId,
    types,
    skip,
    limit = 20,
    utcOffset
  }: {
    orgId: string | undefined;
    types: NotificationQueryType[];
    skip?: number;
    limit?: number;
    utcOffset: string;
  }) => {
    return Get<GetNotificationResponse>(
      `/v1/organizations/${orgId}/notifications`,
      {
        params: {
          types,
          skip,
          limit,
          utcOffset
        }
      }
    );
  },

  getNotificationTotal: async ({
    orgId,
    types
  }: {
    orgId: string | undefined;
    types: NotificationQueryType[];
  }) => {
    return Get<GetNotificationTotalResponse>(
      `/v1/organizations/${orgId}/notifications/total`,
      {
        params: {
          types
        }
      }
    );
  },

  updateNotificationStatus: async ({
    orgId,
    id
  }: {
    orgId: string | undefined;
    id: string;
  }) => {
    return Put(`/v1/organizations/${orgId}/notifications/${id}/mark`);
  }
};
